import { ID, IDPrefixes, PrefixedID, RelationshipUpdate } from '@griply/types';

import { createPrefixId } from '../prefix-id';

// Which document holds the references: the linking entity (a goal lists its parents) or each target (a tag lists its tasks).
export enum LinkDocumentSide {
  Linking = 'linking',
  Linked = 'linked',
}

export type BuildLinkUpdatesOptions = {
  linkingId: PrefixedID;
  targetPrefix: IDPrefixes;
  desiredIds: ID[];
  currentIds: ID[];
  side: LinkDocumentSide;
};

export const buildLinkUpdates = ({
  linkingId,
  targetPrefix,
  desiredIds,
  currentIds,
  side,
}: BuildLinkUpdatesOptions): RelationshipUpdate[] => {
  const desired = new Set(desiredIds);
  const current = new Set(currentIds);

  const addedIds = desiredIds.filter((id) => !current.has(id));
  const removedIds = currentIds.filter((id) => !desired.has(id));

  if (!addedIds.length && !removedIds.length) {
    return [];
  }

  if (side === LinkDocumentSide.Linked) {
    return [
      ...addedIds.map((id) => ({
        id: createPrefixId(id, targetPrefix),
        add: [linkingId],
      })),
      ...removedIds.map((id) => ({
        id: createPrefixId(id, targetPrefix),
        remove: [linkingId],
      })),
    ];
  }

  return [
    {
      id: linkingId,
      ...(addedIds.length
        ? { add: addedIds.map((id) => createPrefixId(id, targetPrefix)) }
        : {}),
      ...(removedIds.length
        ? { remove: removedIds.map((id) => createPrefixId(id, targetPrefix)) }
        : {}),
    },
  ];
};
